'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var React = require('react');
var utils_bindFns = require('../../utils/bind-fns.js');
var clsx = require('clsx');
var faCaretDown = require('@fortawesome/pro-solid-svg-icons/faCaretDown');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var components_Tooltip_Tooltip_component = require('../Tooltip/Tooltip.component.js');
var twMerge = require('../../tw-merge-2e22aa15.js');
require('@fortawesome/sharp-solid-svg-icons/faQuestionCircle');
require('@headlessui/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var _excluded = ["className", "disabled", "hint", "label", "state", "validationText", "options", "tooltipContent", "placeholder", "onChange", "value", "wrapperClassName"],
    _excluded2 = ["input", "meta", "onChange", "onFocus", "onBlur"],
    _excluded3 = ["field", "form", "onChange", "onBlur"];
var Select = React__default["default"].forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      hint = _ref.hint,
      label = _ref.label,
      state = _ref.state,
      validationText = _ref.validationText,
      options = _ref.options,
      tooltipContent = _ref.tooltipContent,
      placeholder = _ref.placeholder,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      value = _ref.value,
      wrapperClassName = _ref.wrapperClassName,
      restSelectProps = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);

  var uniqueId = React__default["default"].useId();
  var selectId = "medipass-select-" + uniqueId;

  var _React$useState = React__default["default"].useState(value),
      selectedOption = _React$useState[0],
      setSelectedOption = _React$useState[1];

  function handleOnChange(event) {
    var selectedValue = event.target.value;
    setSelectedOption(selectedValue);
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: twMerge.twMerge(wrapperClassName)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex flex-col space-y-1"
  }, label && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mb-1 flex items-center text-sm leading-none"
  }, /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: selectId,
    className: "text-basic-darkest font-semibold leading-4"
  }, label), tooltipContent && /*#__PURE__*/React__default["default"].createElement(components_Tooltip_Tooltip_component.Tooltip, {
    content: tooltipContent
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React__default["default"].createElement("select", _extends__default["default"]({
    ref: ref,
    id: selectId,
    disabled: disabled,
    onChange: utils_bindFns.bindFns(handleOnChange, onChange)
  }, hint && {
    'aria-describedby': selectId + "-hint"
  }, validationText && {
    'aria-describedby': selectId + "-error",
    'aria-invalid': true
  }, {
    className: twMerge.twMerge(clsx__default["default"]('h-form-field border-neutral-darker focus:border-primary-base focus:ring-primary-base w-full cursor-pointer appearance-none border bg-white p-2.5 pr-4 text-base transition focus:outline-none focus:ring-1', {
      'bg-neutral-lighter shadow-none text-gray-400 cursor-not-allowed': disabled
    }, state && [{
      'border-primary-base shadow-[0px_0px_0px_1px] shadow-secondary-base': state === 'primary',
      'border-secondary-base shadow-[0px_0px_0px_1px] shadow-primary-base': state === 'secondary',
      'border-danger-base shadow-[0px_0px_0px_1px] shadow-danger-base': state === 'danger',
      'border-warning-base shadow-[0px_0px_0px_1px] shadow-warning-base': state === 'warning',
      'border-success-base shadow-[0px_0px_0px_1px] shadow-success-base': state === 'success'
    }], className, {
      'text-basic-darkest': Boolean(selectedOption),
      'text-gray-400': !selectedOption
    }))
  }, restSelectProps, {
    value: selectedOption
  }), placeholder && /*#__PURE__*/React__default["default"].createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), options.map(function (option) {
    return /*#__PURE__*/React__default["default"].createElement("option", {
      key: option.key,
      value: option.value
    }, option.label);
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faCaretDown.faCaretDown,
    className: "text-gray-500"
  })))), validationText && /*#__PURE__*/React__default["default"].createElement("p", {
    id: selectId + "-error",
    className: clsx__default["default"]('!mt-0 text-sm', state && [{
      'text-primary-base': state === 'primary',
      'text-secondary-base': state === 'secondary',
      'text-danger-base': state === 'danger',
      'text-warning-base': state === 'warning',
      'text-success-base': state === 'success'
    }])
  }, validationText), hint && /*#__PURE__*/React__default["default"].createElement("p", {
    id: selectId + "-hint",
    className: "mt-2 text-sm"
  }, hint));
});

function ReduxFormSelectField(_ref2) {
  var input = _ref2.input,
      meta = _ref2.meta,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      _ref2$onFocus = _ref2.onFocus,
      onFocus = _ref2$onFocus === void 0 ? function () {} : _ref2$onFocus,
      _ref2$onBlur = _ref2.onBlur,
      onBlur = _ref2$onBlur === void 0 ? function () {} : _ref2$onBlur,
      props = _objectWithoutPropertiesLoose__default["default"](_ref2, _excluded2);

  var state = (props == null ? void 0 : props.state) || (meta.touched && meta.error ? 'danger' : undefined);
  var validationText = (props == null ? void 0 : props.validationText) || (meta.touched && meta.error ? meta.error : undefined);
  return /*#__PURE__*/React__default["default"].createElement(Select, _extends__default["default"]({}, props, input, {
    state: state,
    validationText: validationText,
    onChange: utils_bindFns.bindFns(input == null ? void 0 : input.onChange, onChange),
    onFocus: utils_bindFns.bindFns(input == null ? void 0 : input.onFocus, onFocus),
    onBlur: utils_bindFns.bindFns(input == null ? void 0 : input.onBlur, onBlur)
  }));
}

function FormikInputField(_ref3) {
  var _form$touched, _form$errors;

  var field = _ref3.field,
      form = _ref3.form,
      _ref3$onChange = _ref3.onChange,
      onChange = _ref3$onChange === void 0 ? function () {} : _ref3$onChange,
      _ref3$onBlur = _ref3.onBlur,
      onBlur = _ref3$onBlur === void 0 ? function () {} : _ref3$onBlur,
      props = _objectWithoutPropertiesLoose__default["default"](_ref3, _excluded3);

  var isTouched = form == null ? void 0 : (_form$touched = form.touched) == null ? void 0 : _form$touched[field == null ? void 0 : field.name];
  var error = form == null ? void 0 : (_form$errors = form.errors) == null ? void 0 : _form$errors[field == null ? void 0 : field.name];
  var state = (props == null ? void 0 : props.state) || (isTouched && error ? 'danger' : undefined);
  var validationText = (props == null ? void 0 : props.validationText) || (isTouched && error ? error == null ? void 0 : error.toString() : undefined);
  return /*#__PURE__*/React__default["default"].createElement(Select, _extends__default["default"]({}, props, field, {
    state: state,
    validationText: validationText,
    onChange: utils_bindFns.bindFns(field == null ? void 0 : field.onChange, onChange),
    onBlur: utils_bindFns.bindFns(field == null ? void 0 : field.onBlur, onBlur)
  }));
}

var _Select = Object.assign(Select, {
  ReduxForm: ReduxFormSelectField,
  Formik: FormikInputField
});

exports.Select = _Select;
